import { render } from "./ShippingMethodBasicInfo.vue?vue&type=template&id=ec4bc58c&scoped=true&ts=true"
import script from "./ShippingMethodBasicInfo.vue?vue&type=script&lang=ts"
export * from "./ShippingMethodBasicInfo.vue?vue&type=script&lang=ts"

import "./ShippingMethodBasicInfo.vue?vue&type=style&index=0&id=ec4bc58c&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec4bc58c"]])

export default __exports__